import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { 
  Grid, Col, PageHeader, Panel, Glyphicon, Table,
  Form, FormGroup, ControlLabel, FormControl, ButtonGroup, Button, Checkbox
} from "react-bootstrap"
import DatePicker from "react-bootstrap-date-picker"

import { Map, fromJS } from "immutable"
import uuidv4 from "uuid"
import moment from "moment-timezone"
import "moment/locale/id"
import numeral from "numeral"
import "whatwg-fetch"
import FileSaver from "file-saver"

import { processInt, socket_protocol, socket_host, socket_port, upload_path } from "./Common"
import * as actionCreators from "../actions"

moment.tz.setDefault("Asia/Jakarta")

const listAddress = "/orders"
// const recordType = "orders"

class Order extends Component {
  static propTypes = {
    order: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  }

  state = {
    isEdited: false,
    edited: Map()
  }

  getValue = (name, isDate = false) => {
    let value = (this.state.edited && this.state.edited.get(name)) || (this.props.order && this.props.order.get(name)) || ""
    return (isDate ? (value ? moment(value).format() : moment().format()) : value)
  }

  getDetailValue = (name, detailObject, detailId) => {
    return (this.state.edited && this.state.edited.getIn([detailObject, detailId, name])) || 
      (this.props.order && this.props.order.getIn([detailObject, detailId, name])) || ""
  }

  handleSubmit = e => {
    e.preventDefault()

    const { edited } = this.state
    let errors = ""

    // Check mandatory fields
    if (!this.getValue("orderNo"))
      errors = (errors.length > 0 ? "\n" : "") + "Order No. cannot be empty!"
    else if (this.props.orders.filter((item, key) => (item.get("orderNo") === edited.get("orderNo"))).size > 0)
      errors = (errors.length > 0 ? "\n" : "") + "Order No. already exists!"
    
    if (!this.getValue("orderDate"))
      errors = (errors.length > 0 ? "\n" : "") + "Order Date cannot be empty!"
    if (!this.getValue("dealerUuid"))
      errors = (errors.length > 0 ? "\n" : "") + "Dealer Name cannot be empty!"
    if (!this.getValue("customerName"))
      errors = (errors.length > 0 ? "\n" : "") + "Customer Name cannot be empty!"

    // Check details
    if (this.props.order.get("details").size === 0 && (!edited.get("details") || edited.get("details").size === 0))
      errors = (errors.length > 0 ? "\n" : "") + "Item cannot be empty!"
    else if (edited.get("details") && edited.get("details").size > 0)
      edited.get("details").keySeq().forEach(id => {
        if (!this.getDetailValue("productName", "details", id))
          errors = (errors.length > 0 ? "\n" : "") + "Product Name cannot be empty!"
        if (!this.getDetailValue("orderQuantity", "details", id))
          errors = (errors.length > 0 ? "\n" : "") + "Quantity cannot be empty!"
        if (!this.getDetailValue("purchasePrice", "details", id))
          errors = (errors.length > 0 ? "\n" : "") + "Purchase Price cannot be empty!"
        // if (!this.getDetailValue("salesPrice", "details", id))
        //   errors = (errors.length > 0 ? "\n" : "") + "Sales Price cannot be empty!"
      })

    if (errors) {
      console.error("Error in submitting Order:", errors)
      alert(errors)
      return
    }
    this.props.actions.updateOrder(this.props.uuid, edited)
    this.props.history.push(listAddress)
  }

  handleClose = e => {
    if (!this.state.isEdited ||
      window.confirm("There are changes unsaved, are you sure you want to close? (Changes will not be saved if you close now)")) {
      this.props.history.push(listAddress)
    }
  }

  handleCancel = e => {
    if (window.confirm("Are you sure you want to cancel this order?")) {
      this.props.actions.updateOrder(this.props.uuid, { orderStatus: "BATAL" })
      this.props.history.push(listAddress)
    }
  }

  handleSent = e => {
    if (window.confirm("Are you sure you want to tagged this order as TERKIRIM?")) {
      this.props.actions.updateOrder(this.props.uuid, { orderStatus: "TERKIRIM" })
    }
  }

  handleChange = e => {
    const { name } = e.target
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    this.setState((prev, props) => ({
      isEdited: true,
      edited: prev.edited.set(name, value)
    }))
  }

  handleDetailAdd = e => {
    const uuid = `_new_${uuidv4()}`
    const orderUuid = this.props.order.get("uuid")
    this.setState((prev, props) => ({
      edited: prev.edited.setIn(["details", uuid], fromJS({ uuid, orderUuid }))
    }))
  }

  recalculateAmounts = () => {
    this.setState((prev, props) => {
      let edited = prev.edited

      // Recalculate purchaseAmount & salesAmount
      let purchaseAmount = 0
      let salesAmount = 0
      let commissionTotal = 0

      // Existing items
      this.props.order.get("details").forEach((detail, key) => {
        if (!this.getDetailValue("_destroy", "details", key)) {
          let qty = processInt(this.getDetailValue("orderQuantity", "details", key))
          let purchase = processInt(this.getDetailValue("purchasePrice", "details", key))
          let sales = processInt(this.getDetailValue("salesPrice", "details", key))
          let comm = processInt(this.getDetailValue("commission", "details", key))
          
          purchaseAmount += qty * purchase
          salesAmount += qty * sales
          commissionTotal += comm
        }
      })

      // New items
      edited.get("details").forEach((detail, key) => {
        if (key.substr(0, 5) === "_new_") {
          const qty = processInt(detail.get("orderQuantity"))
          const purchase = processInt(detail.get("purchasePrice"))
          const sales = processInt(detail.get("salesPrice"))
          const comm = processInt(detail.get("commission"))
          
          purchaseAmount += qty * purchase
          salesAmount += qty * sales
          commissionTotal += comm
        }
      })

      edited = edited.merge({ purchaseAmount, salesAmount, commissionTotal })

      return { edited }
    })
  }

  handleDetailChange = e => {
    const { id, name } = e.target
    let { value } = e.target

    this.setState((prev, props) => {
      let edited = prev.edited
      
      if (["orderQuantity", "purchasePrice", "salesPrice", "commission"].indexOf(name) !== -1)
        value = processInt(value)

      edited = edited.setIn(["details", id, name], value)
      
      // Get previous values
      // const prevPurchaseAmount = processInt(this.getValue("purchaseAmount"))
      // const prevSalesAmount = processInt(this.getValue("salesAmount"))
      // const prevQuantity = processInt(this.getDetailValue("orderQuantity", "details", id))
      // const prevPurchasePrice = processInt(this.getDetailValue("purchasePrice", "details", id))
      // const prevSalesPrice = processInt(this.getDetailValue("salesPrice", "details", id))
      // const prevCommission = processInt(this.getDetailValue("commission", "details", id))

      // if (name === "orderQuantity" && prevSalesPrice > 0) {  
      //   // Update related fields
      //   value = processInt(value)
      //   if ()
      //   edited = edited.set("purchaseAmount", prevPurchaseAmount + ((value - prevQuantity) * prevPurchasePrice))
      //   edited = edited.set("salesAmount", prevSalesAmount + ((value - prevQuantity) * prevSalesPrice))
      // } else if (name === "purchasePrice" && prevSalesPrice > 0) {
      //   // Update related fields
      //   value = processInt(value)
      //   edited = edited.set("purchaseAmount", prevPurchaseAmount + (prevQuantity * (value - prevPurchasePrice)))
      // } else if (name === "salesPrice") {
      //   // Update related fields
      //   value = processInt(value)
      //   if (value === 0)
      //     edited = edited.merge({ purchaseAmount: 0, salesAmount: 0 })
      //   else
      //     edited = edited.set("salesAmount", prevSalesAmount + (prevQuantity * (value - prevSalesPrice)))
      // } else if (name === "commssion") {
      //   // Update related fields
      //   value = processInt(value)
      //   edited = edited.set("salesAmount", prevSalesAmount + (value - prevCommission))
      // }
      return { isEdited: true, edited }
    }, () => this.recalculateAmounts())
  }

  handleDetailDelete = e => {
    const { id } = e.target

    if (window.confirm("Are you sure you want to delete this item?")) {
      if (id.substr(0, 5) === "_new_") {
        this.setState((prev, props) => ({
          edited: prev.edited.deleteIn(["details", id])
        }), () => this.recalculateAmounts())
      } else {
        this.setState((prev, props) => ({
          edited: prev.edited.setIn(["details", id, "_destroy"], true)
        }), () => this.recalculateAmounts())
      }
    }
  }

  handleOrderDateChange = (value, formattedValue) => {
    this.setState((prev, props) => ({
      edited: prev.edited.set(
        "orderDate",
        moment(value).format()
      )
    }))
  }

  handleDealerPaid = e => {
    e.preventDefault()
    if (window.confirm("Are you sure you want to change Dealer Paid status?")) {
      const { value } = e.target
      this.props.actions.updateOrder(this.props.uuid, { purchaseStatus: value })
    }
  }

  handlePaymentReceived = e => {
    e.preventDefault()
    if (window.confirm("Are you sure you want to change Payment Received status?")) {
      const { value } = e.target
      // const orderStatus = value === "YES" ? "TERKIRIM" : "BARU"
      this.props.actions.updateOrder(this.props.uuid, { salesStatus: value })
    }
  }

  handlePrint = e => {
    e.preventDefault()
    const { name } = e.target

    const otherWindow = window.open()
    otherWindow.opener = null
    otherWindow.location = `${socket_protocol}//${socket_host}:${socket_port}${upload_path}/${name}/${this.getValue("orderNo")}.pdf`
  }

  handleDownload = e => {
    e.preventDefault()

    const { name } = e.target

    let url = `${socket_protocol}//${socket_host}:${socket_port}${upload_path}/${name}/${this.getValue("orderNo")}.pdf`

    // Fetch url then save
    fetch(url).then(res => res.blob())
    .then(blob => FileSaver.saveAs(blob, name + "_" + this.getValue("orderNo") + ".pdf"))
  }

  render() {
    return (
      <Form horizontal onSubmit={this.props.handleSubmit}>
        <Grid>
          <PageHeader>Order {this.getValue("orderNo")}</PageHeader>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>No. Pesanan</Col>
            <Col sm={4}>
              <FormControl
                name="orderNo"
                placeholder="No. Pesanan"
                value={this.getValue("orderNo")}
                onChange={this.handleChange} />
            </Col>
            <Col componentClass={ControlLabel} sm={2}>Tanggal Pesanan</Col>
            <Col sm={4}>
              <DatePicker name="orderDate" placeholder="Tanggal Pesanan" showClearButton={false}
                value={this.getValue("orderDate", true)}
                onChange={this.handleOrderDateChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Nama Dealer</Col>
            <Col sm={8}>
                <FormControl
                componentClass="select"
                name="dealerUuid"
                placeholder="Nama Dealer"
                value={this.getValue("dealerUuid")}
                onChange={this.handleChange}>
                  <option></option>
                  {this.props.dealers.valueSeq().map(d =>
                    <option key={d.get("uuid")} value={d.get("uuid")}>{d.get("dealerName")}</option>
                  )}
              </FormControl> 
            </Col>
            <Col sm={2}>
              <Checkbox name="isSelfDelivery"
                checked={this.getValue("isSelfDelivery")}
                onChange={this.handleChange}>
                Self Delivery
              </Checkbox>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Nama Customer</Col>
            <Col sm={4}>
              <FormControl
                name="customerName"
                placeholder="Nama Customer"
                value={this.getValue("customerName")}
                onChange={this.handleChange} />
            </Col>
            <Col componentClass={ControlLabel} sm={2}>Telepon Customer</Col>
            <Col sm={4}>
              <FormControl
                name="customerPhone1"
                placeholder="Telepon Customer"
                value={this.getValue("customerPhone1")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Alamat Customer</Col>
            <Col sm={10}>
              <FormControl
                componentClass="textarea"
                rows="5"
                name="customerAddress"
                placeholder="Alamat Customer"
                value={this.getValue("customerAddress")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>

          <u>Rincian Pesanan:</u>
          <Table fill responsive>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th className="text-center col-sm-3">Nama Barang</th>
                <th className="text-center col-sm-1">Qty.</th>
                <th className="text-center col-sm-2">Harga Modal</th>
                <th className="text-right col-sm-1">Total Modal</th>
                <th className="text-center col-sm-2">Komisi</th>
                <th className="text-center col-sm-2">Harga Jual</th>
                <th className="text-right col-sm-1">Total Jual</th>
              </tr>
            </thead>
            <tbody>
              {this.props.order && this.props.order.get("details").keySeq().map(id => (
                this.getDetailValue("_destroy", "details", id) ? null :
                <tr key={id}>
                  <td className="text-center" style={{ verticalAlign: "middle" }}>
                    <Button bsSize="xsmall" bsStyle="danger" id={id} onClick={this.handleDetailDelete}>
                      <Glyphicon glyph="trash" id={id} />
                    </Button>
                  </td>
                  <td className="text-center">
                    <FormControl className="text-center" id={id} name="productName"
                      value={this.getDetailValue("productName", "details", id)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-center">
                    <FormControl className="text-center" id={id} name="orderQuantity"
                      value={this.getDetailValue("orderQuantity", "details", id)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-center">
                    <FormControl className="text-right" id={id} name="purchasePrice"
                      value={this.getDetailValue("purchasePrice", "details", id)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-right" style={{ verticalAlign: "middle" }}>
                    {numeral(this.getDetailValue("orderQuantity", "details", id) *
                      this.getDetailValue("purchasePrice", "details", id)).format("0,0")}
                  </td>
                  <td className="text-center">
                    <FormControl className="text-right" id={id} name="commission"
                      value={this.getDetailValue("commission", "details", id)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-center">
                    <FormControl className="text-right" id={id} name="salesPrice"
                      value={this.getDetailValue("salesPrice", "details", id)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-right" style={{ verticalAlign: "middle" }}>
                    {numeral(this.getDetailValue("orderQuantity", "details", id) *
                      this.getDetailValue("salesPrice", "details", id)).format("0,0")}
                  </td>
                </tr>
              ))}
              {this.state.edited.get("details") && this.state.edited.get("details").keySeq().map(key => (
                key.substr(0,5) !== "_new_" ? null :
                <tr key={key}>
                  <td className="text-center" style={{ verticalAlign: "middle" }}>
                    <Button bsSize="xsmall" bsStyle="danger" id={key} onClick={this.handleDetailDelete}>
                      <Glyphicon glyph="trash" id={key} />
                    </Button>
                  </td>
                  <td>
                    <FormControl id={key} name="productName"
                      value={this.getDetailValue("productName", "details", key)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-center">
                    <FormControl className="text-center" id={key} name="orderQuantity"
                      value={this.getDetailValue("orderQuantity", "details", key)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-center">
                    <FormControl className="text-right" id={key} name="purchasePrice"
                      value={this.getDetailValue("purchasePrice", "details", key)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-right" style={{ verticalAlign: "middle" }}>
                    {numeral(this.getDetailValue("orderQuantity", "details", key) * 
                      this.getDetailValue("purchasePrice", "details", key)).format("0,0")}
                  </td>
                  <td className="text-center">
                    <FormControl className="text-right" id={key} name="commission"
                      value={this.getDetailValue("commission", "details", key)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-center">
                    <FormControl className="text-right" id={key} name="salesPrice"
                      value={this.getDetailValue("salesPrice", "details", key)}
                      onChange={this.handleDetailChange} />
                  </td>
                  <td className="text-right" style={{ verticalAlign: "middle" }}>
                    {numeral(this.getDetailValue("orderQuantity", "details", key) * 
                      this.getDetailValue("salesPrice", "details", key)).format("0,0")}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">&nbsp;</td>
                <td className="text-right">{numeral(this.getValue("purchaseAmount")).format("0,0")}</td>
                <td className="text-right">{numeral(this.getValue("commissionTotal")).format("0,0")}</td>
                <td>&nbsp;</td>
                <td className="text-right">{numeral(this.getValue("salesAmount")).format("0,0")}</td>
              </tr>
            </tfoot>
          </Table>

          <FormGroup>
            <Col className="text-right" componentClass={ControlLabel} sm={3}>Ongkos Kirim (Supplier): Rp. </Col>
            <Col sm={9}>
              <FormControl type="number" name="dealerDeliveryFee"
                placeholder="Ongkos Kirim (Supplier)"
                value={this.getValue("dealerDeliveryFee")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col className="text-right" componentClass={ControlLabel} sm={3}>Ongkos Kirim (Customer): Rp. </Col>
            <Col sm={9}>
              <FormControl type="number" name="customerDeliveryFee"
                placeholder="Ongkos Kirim (Customer)"
                value={this.getValue("customerDeliveryFee")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          
          {this.getValue("orderStatus") === "BATAL" ? null :
            <Panel bsSize="small">
              <ButtonGroup>
                <Button bsSize="small" name="faktur" onClick={this.handlePrint}>
                  Print Faktur
                </Button>
                &nbsp;
                <Button bsSize="small" name="faktur" onClick={this.handleDownload}>
                  Download Faktur
                </Button>
                {/* &nbsp;
                <Button bsSize="small" name="faktur" onClick={this.handleEmail}>
                  Email Faktur
                </Button> */}
              </ButtonGroup>
              &nbsp;
              <ButtonGroup>
                &nbsp;
                <Button bsSize="small" name="po" onClick={this.handlePrint}>
                  Print PO
                </Button>
                &nbsp;
                <Button bsSize="small" name="po" onClick={this.handleDownload}>
                  Download PO
                </Button>
                {/* &nbsp;
                <Button bsSize="small" name="po" onClick={this.handleEmail}>
                  Email PO
                </Button> */}
              </ButtonGroup>
              &nbsp;
              <ButtonGroup className="pull-right">
                <Button bsSize="small"
                  bsStyle={this.props.order && this.props.order.get("purchaseStatus") === "YES" ? "success" : "default"}
                  value={this.getValue("purchaseStatus") === "YES" ? "NO" : "YES"}
                  onClick={this.handleDealerPaid}>
                  Dealer Paid
                </Button>
                &nbsp;
                <Button bsSize="small"
                  bsStyle={this.props.order && this.props.order.get("salesStatus") === "YES" ? "success" : "default"}
                  value={this.getValue("salesStatus") === "YES" ? "NO" : "YES"}
                  onClick={this.handlePaymentReceived}>
                  Payment Received
                </Button>
              </ButtonGroup>
            </Panel>
          }

          <Panel bsSize="small">
            <Button bsSize="small" bsStyle="danger" onClick={this.handleClose}>
              <Glyphicon glyph="list" /> Close
            </Button>
            &nbsp;
            {this.getValue("orderStatus") === "BATAL" ? null :
              <ButtonGroup>
                <Button bsSize="small" bsStyle="warning" onClick={this.handleCancel}>
                  <Glyphicon glyph="remove" /> Batal
                </Button>
                &nbsp;
                {this.getValue("orderStatus") === "TERKIRIM" ? null :
                <Button bsSize="small" bsStyle="success" onClick={this.handleSent}>
                  <Glyphicon glyph="send" /> Terkirim
                </Button>
                }
              </ButtonGroup>
            }
            &nbsp;
            {this.getValue("orderStatus") === "BATAL" ? null :
              <ButtonGroup className="pull-right">
                <Button bsSize="small" bsStyle="info" onClick={this.handleDetailAdd}>
                  <Glyphicon glyph="plus" /> Add Item
                </Button>
                &nbsp;
                <Button bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
                  <Glyphicon glyph="save" /> {this.props.order ? "Update" : "Submit"} Order
                </Button>
              </ButtonGroup>
            }
          </Panel>
        </Grid>
      </Form>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  uuid: ownProps.match.params.id,
  dealers: state.get("dealers") || Map(),
  orders: state.get("orders") || Map(),
  order: state.getIn(["orders", ownProps.match.params.id])
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Order))



// WEBPACK FOOTER //
// ./src/components/Order.js